export default __webpack_public_path__ + "static/media/Learn_to_read_Logo.cee86927.svg";